<template>
  <div>
    <div class="instruments-list-container__details">
      <div>
        <h2 class="instruments-list-container-text--primary text-h-3">
          {{ searchValue }}
        </h2>
        <p class="instruments-list-container-text--secondary text-p-5">
          {{ instruments.length }} resultado(s) encontrado(s)
        </p>
      </div>
      <Select
        class="instruments-list-container__select"
        :on-select="onFilterSelect"
        :options="filters"
        :default-value="selectedFilter"
        options-start-position="left"
        data-testid="instruments-list-select"
      />
    </div>
    <HelperView
      v-if="instruments.length === 0"
      class="instruments-list-container__helper--empty"
      title="Não encontramos nenhum resultado"
      description="Veja se digitou corretamente."
    >
      <template #icon>
        <RoundedIcon
          aria-hidden="true"
          icon-name="ic_search_empty"
          icon-size="29"
          background-size="64"
          :main-color="NebraskaColors.statusInfoBackground"
          :text-color="NebraskaColors.statusInfo"
        />
      </template>
    </HelperView>
    <template v-else>
      <InstrumentList
        :chevron="false"
        :on-row-click="onRowClick"
        :search-items-data="instruments"
        show-watch-list-button
        @on-watchlist-click="handleWatchlistClick"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

import { Instrument } from '@/modules/trade/services/search';
import {
  trackInstrumentClick,
  trackWatchlistButtonClick
} from '@/modules/trade/views/SearchListView/trackers';

import {
  HelperView,
  Select,
  RoundedIcon,
  IFilterOption
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { InstrumentList } from '@/modules/trade/components/InstrumentList';

@Component({
  components: {
    InstrumentList,
    HelperView,
    RoundedIcon,
    Select
  }
})
export default class InstrumentsListContainer extends Vue {
  private NebraskaColors = NebraskaColors;

  @Prop({ type: Function, required: true })
  private onFilterSelect!: (filter: IFilterOption) => {};

  @Prop({ type: Object, required: true })
  private selectedFilter!: IFilterOption;

  @Prop({ type: Array, required: true })
  private filters!: IFilterOption[];

  @Prop({ type: Array, required: true })
  private instruments!: Instrument[];

  @Prop({ type: String, required: true })
  private searchValue!: string;

  private onRowClick(instrument: Instrument) {
    trackInstrumentClick(instrument.symbol, instrument.description);

    this.$router.push({
      name: 'tradeInstrument',
      params: { ticker: instrument.symbol }
    });
  }

  handleWatchlistClick(instrument: Instrument) {
    trackWatchlistButtonClick(instrument.symbol, instrument.description);
  }
}
</script>

<style scoped lang="less">
.instruments-list-container {
  &-text {
    &--primary {
      color: @text-primary;
      margin: 0;
      word-wrap: break-all;
    }

    &--secondary {
      color: @text-secondary;
    }
  }

  &__helper {
    &--empty {
      padding-top: @size-spacing-x400;
    }
  }

  &__details {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 0;
    margin-bottom: @size-spacing-x400;
  }

  &__select {
    margin-left: auto;
    background: @divider-primary;
    border-radius: 32px;
    width: auto;

    &/deep/ .select-options {
      min-width: 180px;
    }
  }
}
</style>
